import { render, staticRenderFns } from "./satellite.vue?vue&type=template&id=b326f22a&scoped=true&"
import script from "./satellite.vue?vue&type=script&lang=js&"
export * from "./satellite.vue?vue&type=script&lang=js&"
import style0 from "./satellite.vue?vue&type=style&index=0&id=b326f22a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b326f22a",
  null
  
)

export default component.exports